// @ts-nocheck
import { useLayoutEffect, useState } from 'react';
import { createTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import { cloneDeep, merge } from 'lodash';

import darkThemeConfig from './dark';
import lightThemeConfig from './light';
import useThemeAppearance from '../hooks/Configuration/useThemeAppearance';

const LIGHT_THEME = 'light';

/**
 * @description Custom hook to get the current theme based on the theme value.
 * @returns {object} - The current theme object.
 */
const useCurrentTheme = () => {
  const { getCurrentTheme } = useThemeAppearance();
  const themeMode = useSelector((state) => state?.users?.themeMode);
  const { isAuthenticate } = useSelector((state) => state.users);
  const [theme, setTheme] = useState(
    themeMode === LIGHT_THEME
      ? createTheme(lightThemeConfig)
      : createTheme(darkThemeConfig)
  );

  useLayoutEffect(() => {
    if (isAuthenticate) {
      getCurrentTheme({ theme: themeMode }).then((res) => {
        if (res?.data) {
          const newTheme = res.data?.saved_theme;
          setTheme(
            themeMode === LIGHT_THEME
              ? createTheme(
                  merge(cloneDeep(lightThemeConfig), cloneDeep(newTheme))
                )
              : createTheme(
                  merge(cloneDeep(darkThemeConfig), cloneDeep(newTheme))
                )
          );
        } else {
          setTheme(
            themeMode === LIGHT_THEME ? lightThemeConfig : darkThemeConfig
          );
        }
      });
    }
  }, [themeMode, isAuthenticate]);

  return theme;
};

export default useCurrentTheme;
